export const scrubSensitive = <T>(data: T): T => {
    if (data == null) {
        return data as T;
    }
    if (Array.isArray(data)) {
        return data.map(scrubSensitive) as T;
    }
    if (typeof data === "object") {
        const result: Record<string, unknown> = {};
        for (const [key, value] of Object.entries(data as Record<string, unknown>)) {
            if (/password|token|secret|authorization|auth|cookie|set-cookie/i.test(key)) {
                result[key] = "[REDACTED]";
                continue;
            }
            if (typeof value === "string") {
                if (/^Bearer\s+/i.test(value) || /eyJ[A-Za-z0-9_-]{10,}\./.test(value)) {
                    result[key] = "[REDACTED]";
                    continue;
                }
                if (value.length > 512) {
                    result[key] = `${value.slice(0, 512)}…`;
                    continue;
                }
            }
            result[key] = scrubSensitive(value as never);
        }
        return result as T;
    }
    return data as T;
};
